async function DJShopDev__updateShippingSlider(debugCalledFrom = null) {
  if (debugCalledFrom) {console.log(`debugCalledFrom: ${debugCalledFrom}`)} else {console.log('called but no location')}
  //Check there is actually something on the page to update
  const pageTag = document.getElementById("djshopdev_shipping_slidder_page");
  const cartTag = document.getElementById("djshopdev_shipping_slidder_cart");
  if (!pageTag && !cartTag) { console.error('DJShopDev__updateShippingSlider - Nothing to update'); return }

  //Get the updated cart values
  var cartDetail = await DJShopDev__getNewCartInfo();

  if (cartDetail.ok) {
    var cartJson = await cartDetail.json();
    var cartValue = cartJson.items_subtotal_price/100;
    //console.log(`price: ${cartJson.items_subtotal_price}`)
    //console.log(`cartJson: ${cartJson}`)
    DJShopDev__setSliderPercentage(cartValue, 'page');
    DJShopDev__setSliderPercentage(cartValue, 'cart');
    DJShopDev__formatSliderText(cartValue, 'page');
    DJShopDev__formatSliderText(cartValue, 'cart');
  } else {
    console.error(
      "DJShopDev__updateShippingSlider() Error fetching cart info:",
      cartDetail.statusText
    );
  }

  
  //// ******* THIS IS THE CORRECT ONE TO USE ********
  //DJShopDev__setSliderPercentage(0.75);
}

async function DJShopDev__getNewCartInfo() {
  // Return the promise from fetch
  return fetch(window.Shopify.routes.root + "cart.js");
}


function DJShopDev__formatPrice(cartValue) {
  //The incoming number is a number without the decimal place. Hence the fix
  return cartValue.toFixed(2).toLocaleString("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
  });
}


function DJShopDev__setSliderPercentage(cartValue, location = 'page') {

  console.log(`cartValue: ${cartValue} / location: ${location}`)
  const progress = document.getElementById("djshopdev_slider-progress_" + location);
  const thumb = document.getElementById("djshopdev_slider-thumb_" + location);
  //console.log("progress: " + document.getElementById("djshopdev_slider-progress_" + location))
  if (!progress && !thumb) { console.log(`nothing to Update for ${location}`); return }
  
  const freeFreightAt = 15;
  var percentage = Math.min(1, Math.max(0, (cartValue / freeFreightAt)));
  const width = percentage * 100 + "%";
  console.log("width: " + width)
  try {progress.style.width = width;} catch(error) {}
  try {thumb.style.left = width;} catch(error) {}
}

function DJShopDev__setSliderText(textToUpdate, location = 'page') {
  const divToUpdate = document.getElementById("djshopdev_slider-text_" + location);
  var finalHeadder = textToUpdate.trim();
  finalHeadder = finalHeadder.replace('  ', ' ');
  finalHeadder = finalHeadder.toUpperCase();
  
  //console.log(`finalHeadder: ${finalHeadder}`);
  
  try {divToUpdate.innerHTML = finalHeadder;} catch(error) {}
}

function DJShopDev__formatSliderText(cartValue, location = 'page') {

  //console.log(`cartValue: ${cartValue} / location: ${location}`)
  const divToUpdate = document.getElementById("djshopdev_slider-text_" + location);
  const divTemplateBlock = document.getElementById("djshopdev_slider-text-template__hidden_" + location);
  //console.log('divToUpdate: %o', divToUpdate)
  if (!divToUpdate && !divTemplateBlock) { return }
  
  const divTemplate = divTemplateBlock.innerHTML

  const dollarDifference = 15 - cartValue
  //console.log(`dollarDifference: ${dollarDifference}`)

  var finalHeadder = ''; 
  
  try {
    if (dollarDifference <= 0) {
      finalHeadder = 'CONGRATS! FREE SHIPPING <3';
      DJShopDev__setSliderText(finalHeadder, location);
      return;  // Removed parentheses
    }
  } catch (error) {
    //Do Nothing
  }

  
  const formattedCartValue = DJShopDev__formatPrice(dollarDifference);

  //Format Text
  const searchText = "||$||";
  //console.log(`header: ${header}`)
  
  

  if (divTemplate.includes(searchText)) {
    var splitArray = divTemplate.split(searchText);
    //console.log(`Header OUTPUT:: ${splitArray}`)
    var i = 1;
    for (let a of splitArray) {
      //console.log(`a: ${a}`)
      if (a == '') {
        finalHeadder += " $" + formattedCartValue + " "
      } else {
        if (i == 1 ) {
          finalHeadder += a
        } else {
          finalHeadder += " $" + formattedCartValue + " " + a
        }
      }
      i++
    }
  } else {
    finalHeadder = header;
  }

  DJShopDev__setSliderText(finalHeadder, location);

}

document.addEventListener("DOMContentLoaded", function () {
  // Update shipping sliders on the page when it loads
  DJShopDev__updateShippingSlider();
  //console.log("Free Fright at: $15") //debug

  //Subscribe to the cartUpdate events
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        //Update the Shipping Information slider on the cart page when the cart is closed
          DJShopDev__updateShippingSlider('subscribe');
        if (event.source === "cart-items") {
          //Only cart items were updated
          return;
        }
        //this.onCartUpdate();
      }
      )
  
});
